import { createContext, Dispatch, SetStateAction } from "react";

/* eslint-disable import/prefer-default-export */
interface ICallUserContextType {
  callUser: string | null;
  setCallUser: Dispatch<SetStateAction<any>>;
}
export const CallUserContext = createContext<ICallUserContextType | null>(null);
